import React from 'react';
import PersonIcon from '@material-ui/icons/Person';
import ReceiptLongIcon from '@material-ui/icons/Receipt';
import PaymentIcon from '@material-ui/icons/Payment';
import EqualizerIcon from '@material-ui/icons/Equalizer';
import CodeIcon from '@material-ui/icons/Code';
import CoinIcon from '@material-ui/icons/Money';
import ClienteIcon from '@material-ui/icons/Add';
import DeveloperBoardIcon from '@material-ui/icons/DeveloperBoard';
import DoorIcon from '@material-ui/icons/ExitToApp'
export const Sidebardata=[
    {
        title:"Registrar Cliente",
        icon:<ClienteIcon/>,
        link:"/home/registar-cliente"
    }
    ,
    
    {
        title:"Gestão de Clientes",
        icon:<PersonIcon/>,
        link:"/home/gest-cliente"

    },
    {
        title:"Gestão de Contadores",
        icon:<DeveloperBoardIcon/>,   
        link:"/home/gest-contadores"

    },
    {
        title:'PipeLine',
        icon:<DeveloperBoardIcon/>,
        link:'/home/Pipeline'
    },{
        title:"Logout",
        icon:<DoorIcon/>,
         
        link:"/"

    }


];